import React from 'react';
import styled from 'styled-components';
import { GridSection, Eyebrow, SectionTitle } from './GridSection';

const Item = styled.div`
  padding: 20px 0;
  border-top: 1px solid var(--rule);

  &:last-child { border-bottom: 1px solid var(--rule); }
`;

const Head = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 24px;
  align-items: baseline;
  margin-bottom: 6px;

  @media (max-width: 600px) { grid-template-columns: 1fr; }
`;

const School = styled.h3`
  font-family: 'EB Garamond', Georgia, serif;
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--ink);
  margin: 0;
  letter-spacing: -0.005em;
  overflow-wrap: anywhere;
`;

const Degree = styled.div`
  font-style: italic;
  font-size: 1rem;
  color: var(--ink-soft);
  margin-top: 2px;
`;

const Date = styled.div`
  font-style: italic;
  font-size: 0.95rem;
  color: var(--ink-muted);
  text-align: right;

  @media (max-width: 600px) { text-align: left; }
`;

const Coursework = styled.div`
  font-size: 0.95rem;
  color: var(--ink-muted);
  margin-top: 6px;
  overflow-wrap: anywhere;
`;

const education = [
  {
    school: 'New York University · Tandon School of Engineering',
    degree: 'M.S., Computer Engineering',
    date: 'Expected May 2026',
    coursework: 'Distributed systems, cloud architecture, machine learning, deep learning, computer vision, real-time embedded systems'
  },
  {
    school: 'Habib University',
    degree: 'B.S., Computer Science · CGPA 3.51',
    date: 'May 2022',
    coursework: 'Algorithms, operating systems, computer architecture, probability & statistics, quantum computing, computer graphics'
  }
];

function Education() {
  return (
    <GridSection id="education">
      <Eyebrow>v — education</Eyebrow>
      <SectionTitle>Education.</SectionTitle>
      {education.map((e, i) => (
        <Item key={i}>
          <Head>
            <div>
              <School>{e.school}</School>
              <Degree>{e.degree}</Degree>
            </div>
            <Date>{e.date}</Date>
          </Head>
          <Coursework>{e.coursework}</Coursework>
        </Item>
      ))}
    </GridSection>
  );
}

export default Education;
